import { render } from "./Simulador.vue?vue&type=template&id=7f636fdf&scoped=true"
import script from "./Simulador.vue?vue&type=script&lang=js"
export * from "./Simulador.vue?vue&type=script&lang=js"

import "./Simulador.vue?vue&type=style&index=0&id=7f636fdf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f636fdf"]])

export default __exports__